/**
 * Domínio JS de CNPJ (numérico + alfanumérico) — espelha App\Support\Fiscal\Cnpj.
 * Backend continua sendo a fonte de verdade.
 */

function cnpjMaskChars() {
    return { '.': true, '/': true, '-': true, ' ': true };
}

window.normalizeCnpj = function (value) {
    if (value === null || value === undefined) {
        return null;
    }

    var raw = String(value).trim();
    if (raw === '') {
        return null;
    }

    var upper = raw.toUpperCase();
    var mask = cnpjMaskChars();
    var out = '';

    for (var i = 0; i < upper.length; i++) {
        var ch = upper.charAt(i);
        if (mask[ch]) {
            continue;
        }
        if (!/^[A-Z0-9]$/.test(ch)) {
            return null;
        }
        out += ch;
    }

    return out.length === 14 ? out : null;
};

window.stripCnpjFormatting = function (value) {
    if (value === null || value === undefined) {
        return '';
    }

    var upper = String(value).trim().toUpperCase();
    var mask = cnpjMaskChars();
    var out = '';

    for (var i = 0; i < upper.length; i++) {
        var ch = upper.charAt(i);
        if (mask[ch]) {
            continue;
        }
        if (/^[A-Z0-9]$/.test(ch)) {
            out += ch;
        }
    }

    return out;
};

window.formatCnpj = function (value) {
    var n = window.normalizeCnpj(value);
    if (!n) {
        return '';
    }

    return (
        n.substring(0, 2) + '.' +
        n.substring(2, 5) + '.' +
        n.substring(5, 8) + '/' +
        n.substring(8, 12) + '-' +
        n.substring(12, 14)
    );
};

function cnpjCharValue(ch) {
    return ch.charCodeAt(0) - 48;
}

function cnpjModule11Digit(base) {
    var weight = base.length === 12 ? 5 : 6;
    var sum = 0;

    for (var i = 0; i < base.length; i++) {
        sum += cnpjCharValue(base.charAt(i)) * weight;
        weight = weight === 2 ? 9 : weight - 1;
    }

    var resto = sum % 11;
    return String(resto < 2 ? 0 : 11 - resto);
}

window.computeCnpjCheckDigits = function (base12) {
    if (!/^[A-Z0-9]{12}$/.test(base12)) {
        return null;
    }
    var d1 = cnpjModule11Digit(base12);
    var d2 = cnpjModule11Digit(base12 + d1);
    return d1 + d2;
};

window.validaCNPJ = function (cnpj) {
    var normalized = window.normalizeCnpj(cnpj);
    if (!normalized) {
        return false;
    }

    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(normalized)) {
        return false;
    }

    if (/^(.)\1{13}$/.test(normalized)) {
        return false;
    }

    var expected = window.computeCnpjCheckDigits(normalized.substring(0, 12));
    return expected !== null && normalized.substring(12, 14) === expected;
};
